import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  SmallTextBold,
  SmallText,
} from 'ggx-componentlibrary/design/typography/typography.styles'

const PackageContentBlock = ({ packageContent }) => {
  const [t] = useTranslation()
  let text = t(`vn_contents__${packageContent}`)
  text = text === `vn_contents__${packageContent}` ? packageContent : text
  return packageContent ? (
    <>
      <SmallTextBold typographyStyles="c-black">
        {t('transport_content')}
      </SmallTextBold>
      <SmallText typographyStyles="c-grey_dark">{text}</SmallText>
    </>
  ) : null
}

export { PackageContentBlock }
